<template>
  <div @click="openDay">
    <!-- CALENDAR DAY NUMERATION START (first day, second)  -->
    <div class="calendar-row">
      <div class="day">
        <span>{{ day.day }}</span>
      </div>
      <div
        class="notification-count"
        v-if="day.requests ? day.requests.new : false"
      >
        <span>{{ day.requests["new"].length }}</span>
      </div>
    </div>
    <!-- CALENDAR DAY NUMERATION END  -->

    <div v-if="day.isInPrimaryMonth">
      <div
        class="calendar-statistic calendar-statistic_absolute"
        v-if="
          typeof day.requests === 'object' &&
            day.date < fullDate &&
            day.requests &&
            day.requests.metrics != undefined
        "
      >
        <div class="calendar-statistic-item">
          <div class="calendar-statistic-item__box">
            <div
              :style="{
                width: '100%',
                'background-color': getStatisticColors(
                  day.requests.metrics.indicator_1
                ),
                height: `${day.requests.metrics.indicator_1}%`,
              }"
            ></div>
          </div>
          <div
            class="calendar-statistic-item__p"
            :style="{
              color: getStatisticColors(day.requests.metrics.indicator_1),
            }"
          >
            {{ round(day.requests.metrics.indicator_1) }}%
          </div>
        </div>
        <div class="calendar-statistic-item">
          <div class="calendar-statistic-item__box">
            <div
              :style="{
                width: '100%',
                'background-color': getStatisticColors(
                  day.requests.metrics.indicator_2
                ),
                height: `${day.requests.metrics.indicator_2}%`,
              }"
            ></div>
          </div>

          <div
            class="calendar-statistic-item__p"
            :style="{
              color: getStatisticColors(day.requests.metrics.indicator_2),
            }"
          >
            {{ round(day.requests.metrics.indicator_2) }}%
          </div>
        </div>
        <div class="calendar-statistic-item">
          <div class="calendar-statistic-item__box">
            <div
              :style="{
                width: '100%',
                'background-color': getStatisticColors(
                  day.requests.metrics.indicator_3
                ),
                height: `${day.requests.metrics.indicator_3}%`,
              }"
            ></div>
          </div>
          <div
            class="calendar-statistic-item__p"
            :style="{
              color: getStatisticColors(day.requests.metrics.indicator_3),
            }"
          >
            {{ round(day.requests.metrics.indicator_3) }}%
          </div>
        </div>
        <div class="calendar-statistic-item">
          <div class="calendar-statistic-item__box">
            <div
              :style="{
                width: '100%',
                'background-color': getStatisticColors(
                  day.requests.metrics.indicator_4
                ),
                height: `${day.requests.metrics.indicator_4}%`,
              }"
            ></div>
          </div>
          <div
            class="calendar-statistic-item__p"
            :style="{
              color: getStatisticColors(day.requests.metrics.indicator_4),
            }"
          >
            {{ round(day.requests.metrics.indicator_4) }}%
          </div>
        </div>
      </div>

      <div
        class="calendar-statistic calendar-statistic_absolute calendar-statistic_future"
        v-else
      >
        <template v-if="day.requests && day.requests.metrics != null">
          <div class="calendar-statistic-item">
            <div
              class="calendar-statistic-item__box"
              :style="{
                'background-color': getStatisticColors(
                  getStatisticColors2(day.requests.metrics.services)
                ),
                height: `${getStatisticColors2(
                  day.requests.metrics.services
                )}%`,
              }"
            ></div>
            <div
              class="statistic-item__p"
              :style="{
                color: getStatisticColors(
                  getStatisticColors2(day.requests.metrics.services)
                ),
              }"
            >
              {{ getStatisticColors2(day.requests.metrics.services) || 0 }}%
            </div>
          </div>

          <div>
            <p class="calendar-statistic_future__p">
              <img
                src="@/assets/images/elek3.png"
                width="15px"
                height="15px"
                alt
              />
              <span class="ml10">
                {{
                  day.requests.metrics.services.Elektriker
                    .duration_planned_works
                }}
                /
                {{
                  day.requests.metrics.services.Elektriker.duration_working_day
                }}
                std
              </span>
            </p>
            <p class="calendar-statistic_future__p">
              <img
                src="@/assets/images/hand3.png"
                width="15px"
                height="15px"
                alt
              />
              <span class="ml10">
                {{
                  day.requests.metrics.services.Handwerker
                    .duration_planned_works
                }}
                /
                {{
                  day.requests.metrics.services.Handwerker.duration_working_day
                }}
                std
              </span>
            </p>
            <p class="calendar-statistic_future__p">
              <img
                src="@/assets/images/plumber3.png"
                width="15px"
                height="15px"
                alt
              />
              <span class="ml10">
                {{
                  day.requests.metrics.services.Installateur
                    .duration_planned_works
                }}
                /
                {{
                  day.requests.metrics.services.Installateur
                    .duration_working_day
                }}
                std
              </span>
            </p>

            <p
              class="calendar-statistic_future__p"
              v-if="day.requests.metrics.services['Böden/Fliesen']"
            >
              <img
                src="@/assets/images/pll.png"
                width="15px"
                height="15px"
                alt
              />
              <span class="ml10">
                {{
                  day.requests.metrics.services["Böden/Fliesen"]
                    .duration_planned_works
                }}
                /
                {{
                  day.requests.metrics.services["Böden/Fliesen"]
                    .duration_working_day
                }}
                std
              </span>
            </p>
            <!-- Böden/Fliesen -->
          </div>
        </template>

        <template v-else>
          <div class="calendar-statistic-item">
            <div
              class="calendar-statistic-item__box"
              :style="{
                'background-color': getStatisticColors(0),
                height: `0%`,
              }"
            ></div>
          </div>
        </template>
      </div>
    </div>

    <!-- CALENDAR DAY LINES START  -->
    <div
      class="lines"
      v-if="
        !day.isInPrimaryMonth &&
          day.requests &&
          (view == 'default' || view == 'services')
      "
    >
      <div
        class="lines__wrapper"
        v-for="request in day.requests['approved']"
        :key="request.id"
      >
        <div v-for="line in request.requests" :key="line.id" class="lines-box">
          <div
            class="line"
            v-if="line.status != 'canceled'"
            :style="{
              backgroundColor: line.service.color,
              width: '100%',
            }"
          ></div>
        </div>
      </div>
    </div>
    <!-- CALENDAR DAY LINES END  -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import getColor from '@/mixins/getStatisticColors'

const date = new Date(new Date()).getDate()
const fullDate = new Date()
export default {
    name: 'calendar-month-item',
    mixins: [getColor],
    props: {
        day: {
            required: true,
        },
        view: {
            required: true,
        },
        toDay: {
            required: true,
        },
    },
    data() {
        return {
            date,
            fullDate,
        }
    },
    methods: {
        ...mapMutations({
            setOrderData: 'setOrderData',
        }),
        async openDay() {
            if (!this.dayInThisMonth()) {
                return
            }

            this.setOrderData({
                detail: this.day.day,
                showDetails: false,
                isActive: 'day',
                day: this.day.date,
            })
        },
        dayInThisMonth() {
            return this.day.isInPrimaryMonth
        },
        round(n) {
            return Math.round(n)
        },
        getStatisticColors2(metrics) {
            const services = metrics

            if (!services) return 0

            let sold = 0
            let all = 0

            for (const key in services) {
                if (services[key].duration_working_day === 0) return 0

                sold += services[key].duration_planned_works || 0
                all += services[key].duration_working_day || 0
            }
            return Math.round((sold / all) * 100)
        },
    },
}
</script>

<style lang="scss" scoped>
// .lines-box {
//   height: 5px;
// }

// @import "src/assets/sass/main";

// .calendar-month {
//   background-color: #ffffff;
//   border-radius: 8px;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   width: 100%;
//   box-sizing: border-box;
//   // margin-bottom: 36px;
//   &__header {
//     display: flex;
//     height: 50px;

//     &-item {
//       flex-grow: 1;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       font-family: $fontMedium;
//       color: #4d4d4d;
//       font-size: 16px;
//       opacity: 0.2;
//       text-align: center;
//       width: 100%;
//     }
//   }

//   &__body {
//     &-row {
//       display: flex;
//       align-items: stretch;
//       border-collapse: collapse;
//     }

//     &-item {
//       flex-grow: 1;
//       width: 100%;
//       height: 130px;
//       background-color: #ffffff;
//       border: solid 1px #e0e0e0;
//       padding: 9px 20px;
//       box-sizing: border-box;
//       // transition: 0.2s;
//       overflow: hidden;
//       cursor: pointer;

//       &:hover {
//         background-color: rgba(#71bd4a, 0.1);
//       }

//       & .row {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         margin-bottom: 18px;
//       }

//       & .day {
//         font-size: 20px;
//         font-family: $fontMedium;
//         color: var(--menu-text-color);
//       }

//       & .notification-count {
//         width: 24px;
//         height: 24px;
//         background-color: var(--bg-color-green);
//         color: #ffffff;
//         font-size: 12px;
//         font-family: $fontMedium;
//         border-radius: 50%;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         top: 12px;
//       }

//       & .row {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         margin-bottom: 18px;
//       }

//       // & .notification {
//       //   width: 24px;
//       //   height: 24px;
//       //   background-color: #71bd4a;
//       //   color: #ffffff;
//       //   font-size: 12px;
//       //   font-family: $fontMedium;
//       //   border-radius: 50%;
//       //   display: flex;
//       //   justify-content: center;
//       //   align-items: center;
//       // }

//       &.disabled {
//         // background-image: url("/images/icon/Calendar-placeholder.svg");
//         background-size: cover;
//         background-position: center;
//         opacity: 0.1;
//         z-index: 0;
//       }

//       &.current__day {
//         // background-color: rgba(#71bd4a, 0.1);
//         // background: var(--hover-newbg-color);
//       }

//       & .lines {
//         display: flex;
//         flex-direction: column;

//         &__wrapper {
//           display: flex;
//           flex-direction: column;
//         }
//       }

//       & .line {
//         height: 1.5px;
//         // background-color: #00d8ff;
//         display: inline-block;
//         width: 0;
//         margin-bottom: 2.5px;
//       }

//       & .master {
//         & .line {
//           margin-bottom: 8px;
//           height: 2px;
//         }

//         &__info {
//           display: flex;
//           align-items: center;

//           &-image {
//             width: 30px;
//             height: 30px;
//             border: solid 1px $secondColor;
//             background-size: cover;
//             background-position: center;
//             border-radius: 50%;
//             margin-right: 16px;
//           }

//           &-text {
//           }

//           &-name {
//             color: #4d4d4d;
//             font-size: 10px;
//             font-family: $fontBold;
//             margin-bottom: 2px;
//           }

//           &-time {
//             color: #4d4d4d;
//             font-size: 10px;
//           }

//           &.empty {
//             opacity: 0.4;
//           }
//         }
//       }
//     }
//   }
// }

// .userlist {
//   border-radius: 8px;
//   background-color: #ffffff;
//   width: 100%;
//   height: calc(100% - 86px);
//   position: absolute;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   top: 0;
//   left: 0;

//   &__wrapper {
//     width: 100%;
//     height: 100%;
//     overflow-y: auto;
//     padding-bottom: 24px;
//     box-sizing: border-box;
//   }

//   &__add {
//     position: fixed;
//     right: 40px;
//     bottom: 20px;
//     display: flex;
//     align-items: flex-end;

//     &-text {
//       color: #4d4d4d;
//       font-size: 12px;
//       margin-right: 16px;
//       font-family: $fontMedium;
//     }

//     &-button {
//       width: 56px;
//       height: 56px;
//       border-radius: 50%;
//       background-color: $primaryColor;
//       box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//       background-image: url("/images/icon/add.svg");
//       background-position: center;
//       background-size: 20px;
//       background-repeat: no-repeat;
//       transition: 0.5s;
//       cursor: pointer;

//       &:hover {
//         background-color: $secondColor;
//       }
//     }
//   }

//   &__block {
//     display: flex;
//     position: relative;

//     &-text {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 64px;
//       flex-shrink: 0;
//       font-family: $fontLight;
//       font-size: 30px;
//       color: #e0e0e0;
//       text-align: center;
//       text-transform: uppercase;
//     }
//   }

//   &__items {
//     flex-grow: 1;
//     display: flex;
//     flex-direction: column;
//     // overflow-y: auto;
//     // padding-bottom: 24px;
//   }

//   &__item {
//     position: relative;
//     display: flex;
//     align-items: center;
//     height: 50px;
//     width: 100%;
//     flex-grow: 1;
//     transition: 0.5s;
//     padding-left: 64px;
//     box-sizing: border-box;

//     &:hover {
//       background-color: rgba(#71bd4a, 0.15);

//       & .userlist__item-button {
//         opacity: 1;
//       }
//     }

//     &-img {
//       width: 36px;
//       height: 36px;
//       background-position: center;
//       background-size: cover;
//       border: 1px solid $secondColor;
//       border-radius: 50%;
//       margin-right: 16px;
//       margin-left: 5px;
//     }

//     &-name {
//       font-size: 16px;
//       color: #4d4d4d;
//       font-family: $fontBold;
//       flex-grow: 1;
//       width: 16%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-post {
//       font-size: 12px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 15%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-phone {
//       font-size: 16px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 16%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-mail {
//       font-size: 16px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 15%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-status {
//       width: 10px;
//       height: 10px;
//       border-radius: 50%;
//       background-color: $primaryColor;
//       margin-left: 23px;
//       margin-right: 23px;

//       &--busy {
//         background-color: $secondColor;
//       }
//     }

//     &-buttons {
//       display: flex;
//       align-items: center;
//       flex-grow: 3;
//     }

//     &-button {
//       margin-right: 16px;
//       cursor: pointer;

//       & .icon {
//         width: 30px;
//         height: 30px;
//         transition: 0.5s;

//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }
//   }
// }
</style>
